import { render, staticRenderFns } from "./DisputesManualAdjustments.vue?vue&type=template&id=5457a914&scoped=true"
import script from "./DisputesManualAdjustments.vue?vue&type=script&lang=js"
export * from "./DisputesManualAdjustments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5457a914",
  null
  
)

export default component.exports